import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import axios, { AxiosError, AxiosInstance } from "axios";

/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const baseURL = "https://core-api.refereree.com";
// export const baseURL = "https://core-api.refereree.com";
// export const baseURL = 'https://core-api.refereree.com';
const api: AxiosInstance = axios.create({
  baseURL,
});
export const sourceCancelToken = axios.CancelToken.source();
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers!.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

export interface CreateResponseInterface {
  status: number;
  message: string;
  data: [] | string | object | null;
  errors: [] | string | object | null;
}

export default api;

export const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}`,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");

    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    }
  },
});
